module.exports = "/_next/static/images/8db17a99f1a3e0a3358c11d383170273-stapler@desktop1366.jpg.webp";